<template>
  <div>
    <div class="row">
      <div class="col-md-6 py-0">
        <p class="title mb-0">{{ title }}</p>
        <span class="subtitle">{{ subtitle }}</span>
      </div>
      <div class="col-md-6 py-0">
        <div class="dateRangeContainer float-right position-relative">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Custom Date Range"
                prepend-icon="fa-calendar"
                readonly
                v-bind="attrs"
                @click="toggleMenu"
                clearable
                @click:clear="cleared"
                :loading="dateRangeLoading"
              />
            </template>

            <v-date-picker
              v-model="date"
              no-title
              scrollable
              range
              @change="dateSelected"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
                :disabled="isLoading"
              >
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <div class="options-container position-absolute">
          <v-menu bottom right :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#BDBFC4"
                class="ma-2 white--text"
                fab
                v-bind="attrs"
                v-on="on"
                x-small
                elevation="1"
              >
                <v-icon>fa-ellipsis-v</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item-group multiple active-class="">
                <v-list-item
                  :loading="exportLoading"
                  :disabled="exportLoading"
                  @click="exportData"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-icon v-if="!exportLoading">fa-file-export</v-icon>
                      <v-progress-circular v-else indeterminate color="amber" />
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>Export</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import EventBus from '@/plugins/eventBus';
export default {
  name: 'CardChartHeader',

  props: ['title', 'subtitle', 'getData', 'type'],

  data() {
    return {
      menu: false,
      changedDate: false,

      date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    };
  },

  computed: {
    dateRangeText() {
      if (this.date[0] === null || !this.changedDate) {
        return null;
      }

      const dateFrom = moment(this.date[0]).format('MM/DD/YYYY');
      const dateTo = moment(this.date[1]).format('MM/DD/YYYY');

      return `${dateFrom} ~ ${dateTo}`;
    },

    dateRangeLoading() {
      return this.$store.state.overviewReport.dateRangeLoading;
    },

    componentKey() {
      const title = this.title.toLowerCase();

      switch (true) {
        case title.includes('performers'):
          return 'topPerformers';
        case title.includes('certifications'):
          return 'certifications';
        case title.includes('team'):
          return 'teamProgress';
        default:
          return 'myProgress';
      }
    },

    exportLoading() {
      return this.$store.state.overviewReport.exportLoading;
    },
  },

  created() {
    EventBus.$on('reset', () => {
      this.resetAllFilters();
    });
  },

  methods: {
    toggleMenu() {
      setTimeout(() => {
        this.menu = !this.menu;
      }, 20);
    },

    proceed() {
      this.changedDate = true;
      const dateRange = {
        dateFrom: moment(this.date[0]).format('MM/DD/YYYY'),
        dateTo: moment(this.date[1]).format('MM/DD/YYYY'),
      };

      this.$store.dispatch('overviewReport/setDateRangeLoading', true);
      this.$store.dispatch('overviewReport/setComponentDate', {
        key: this.componentKey,
        value: dateRange,
      });

      this.getData();
    },

    exportData() {
      this.$store.dispatch('overviewReport/setExportLoading', true);
      this.getData();
    },

    cleared() {
      this.$store.dispatch('overviewReport/setDateRangeLoading', true);
      this.$store.dispatch('overviewReport/setComponentDate', {
        key: this.componentKey,
        value: {},
      });

      this.getData();
    },

    dateSelected(value) {
      const dateFrom = moment(value[0]);
      const dateTo = moment(value[1]);
      const dateFormat = 'YYYY-MM-DD';

      // check if the selected "date from" is greater than
      // the "date to", if yes
      // then swap it
      if (dateFrom.isAfter(dateTo)) {
        this.date = [dateTo.format(dateFormat), dateFrom.format(dateFormat)];
      }

      this.proceed();
    },

    resetAllFilters() {
      this.changedDate = false;
    },
  },
};
</script>

<style scoped lang="stylus">
.title
  font-family Roboto
  font-size 16px
  color #757575

.subtitle
  font-family Roboto
  font-size 14px
  color #BDBDBD

.dateRangeContainer
  width 250px
  top -7px

.options-container
  right -15px
  top -30px
</style>
